import {Hydra} from '../generic/hydra';

import {DossierInterface} from './Dossier';
import {
    DossierExpertAcceptationRequest as DossierExpertAcceptationRequestBaseInterface
} from '../../interface/api/DossierExpertAcceptationRequest';

export type DossierExpertAcceptationRequestInterface = DossierExpertAcceptationRequestBaseInterface;

export class DossierExpertAcceptationRequest extends Hydra implements DossierExpertAcceptationRequestInterface {

    dossierExpert?: DossierInterface | string | null;

    declarationLien?: string | null;


    constructor(options: DossierExpertAcceptationRequestInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
